import CloseIcon from '@material-design-icons/svg/filled/close.svg?component'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Provider, ReactReduxContext } from 'react-redux'
import './styles.scss'

const modalRoot = document.getElementById('modal')

export class Modal extends React.Component {
  componentDidMount () {
    document.body.style.overflow = 'hidden'
  }

  componentWillUnmount () {
    document.body.style.overflow = 'auto'
  }

  renderActions () {
    const { actions } = this.props
    if (actions && actions.length && actions.length > 0) {
      const indexedActions = actions.map((a, i) =>
        React.cloneElement(a, { key: `modalAction${i}` }))
      return <div className='modal-actions'>{[ ...indexedActions ]}</div>
    }
    return null
  }

  render () {
    const { title, children, onCancel, onClose } = this.props

    const actions = this.renderActions()

    return (
      <div className='nh-backdrop'>
        <div className='nh-modal'>
          <div className='nh-modal-header'>
            {title && <h2 className='modal-title'>{title}</h2>}
            {(onCancel || onClose) && (
              <button onClick={onCancel || onClose}>
                <CloseIcon fill='#222' />
              </button>
            )}
          </div>
          <div className='modal-content'>
            {children}
          </div>
          {actions}
        </div>
      </div>
    )
  }
}

Modal.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.element),

  children: PropTypes.any
}

const Portal = ({ isOpen, children }) => {
  const modalElement = document.createElement('div')
  useEffect(() => {
    modalRoot?.appendChild(modalElement)
    return () => {
      modalRoot?.removeChild(modalElement)
    }
  }, [ modalElement ])

  return isOpen ? createPortal(children, modalElement) : null
}

Portal.propTypes = {
  children: PropTypes.element.isRequired,
  isOpen: PropTypes.bool
}

Portal.defaultProps = {
  isOpen: false
}

export function PortedModal ({ actions, title, children, open, onCancel, description = '' }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }

    return () => (document.body.style.overflow = 'auto')
  }, [ open ])

  return (
    <ReactReduxContext.Consumer>
      {ctx => (
        <Provider store={ctx.store}>
          <Portal isOpen={open}>
            <div className='nh-backdrop'>
              <div className='nh-modal'>
                <div className='nh-modal-header'>
                  <h2 className='modal-title'>{title}</h2>
                  {onCancel && (
                    <button
                      type='button'
                      onClick={onCancel}
                    >
                      <CloseIcon fill='#555' />
                    </button>
                  )}
                </div>
                <div className='modal-content'>{children ?? description}</div>
                {actions?.length > 0 && (
                  <div className='modal-actions'>{actions}</div>
                )}
              </div>
            </div>
          </Portal>
        </Provider>
      )}
    </ReactReduxContext.Consumer>
  )
}

PortedModal.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.element),
  onCancel: PropTypes.func,
  description: PropTypes.string,

  children: PropTypes.any,
  open: PropTypes.bool
}
